module.exports = __webpack_public_path__ + "static/img/modular-engine_256.ed03959.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/modular-engine_256.png
// module id = yjn9
// module chunks = 0